module.exports = __webpack_public_path__ + "static/octopus-e97c21ef7b7f2ac47c78ea846e325c25.jpeg";